import ContractGenerator from '@/components/ContractGenerator';

const ContractsPage = () => {
  return (
    <div className="app-page contracts-page" data-testid="contracts-page">
      <ContractGenerator />
    </div>
  );
};

export default ContractsPage;
